<!--
اضافة 12 خانة اختياريه
اضافة مقاول معتمد لدى سكيكو

-->

<template>
  <v-container>
    <v-btn to="/">الرجوع للصفحة الرئيسية <v-icon>keyboard_backspace</v-icon></v-btn>
    <v-layout
      align-center
      justify-center
      >
      <v-progress-circular
      v-if="progress"
      indeterminate
      color="primary"
      size=60
      ></v-progress-circular>
    </v-layout>
    <v-layout
      align-center
      justify-center
      v-if="submitted"
      >
      <v-icon>done</v-icon>
شكرا جزيلا  .سيتم التواصل معك في اقرب فرصه    </v-layout>

    <v-form
    v-if="!progress && !submitted"
    ref="contactForm"
    v-model="valid"
    >
      <div class="headline">تواصل معنا </div>
      <v-layout wrap justify-center>
        <v-flex xs6>
          <v-text-field
            v-model="name"
            :rules="nameRules"
            label="الاسم"
            required
            prepend-icon="person"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="البريد الالكتروني"
            required
            prepend-icon="email"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
            v-model="phone"
            :rules = "phoneRules"
            counter=10
            required
            :mask="maskphone"
            label="التلفون"
            prepend-icon="phone"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-select
          v-model='city'
          required
          :items="cities"
          lable="المدينة"
          placeholder="المدن الحالية تحت خدمتنا"
          prepend-icon="place"
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-select
          Opportunitiesv-model='segment'
          :items="segments"
          required
          lable="القطاع"
          placeholder="القطاع"
          ></v-select>
        </v-flex>
        <v-flex xs6>
          <v-textarea
            outline
            required
            v-model="comment"
            label="التعليق"
          ></v-textarea>
        </v-flex>
        <v-flex xs6>
          <div class=".title">الاستهلاك الشهري (الريال السعودي)</div>
          <v-layout wrap justify-center>
              <v-text-field
                v-for="(monthlyConsumption, index) in monthlyConsumptions"
                v-model="monthlyConsumptions[index]"
                v-bind:label="index+1"
              ></v-text-field>
          </v-layout>
        </v-flex>
      <v-btn @click="submit">ارسال</v-btn>
      <v-btn @click="clear">مسح</v-btn>
    </v-layout>
    </v-form>
  </v-container>
</template>
<script>
import axios from 'axios'

export default{
  data: () => ({
    progress: false,
    submitted:false,
    maskphone:'##########',
    segments: ['سكني', 'تجاري'],
    cities: ['الدمام', 'الخبر', 'الجبيل', 'القطيف', 'سيهات', 'صفوى', 'عنك'],
    valid: false,
    name: '',
    phone:'',
    phoneRules:[
       v => (v.length == 10) || 'ادخل ١٠ ارقام',
    ],
    nameRules: [
      v => !!v || 'يجب وضع الاسم ',
      v => v.length >= 10 || 'الاسم يجب ان لا يقل عن ١٠ احرف'
    ],
    email: '',
    emailRules: [
      v => !!v || 'يجب وضع البريد الاكتروني',
      v => /.+@.+/.test(v) || 'يجب وضع بريد الكتروني صحيح'
    ],
    monthlyConsumptions: new Array(12),
  }),
  methods:{
    submit(){
      if(!this.$refs.contactForm.validate()){
        return false
      }
      var serviceUrl= "https://5349234015493829.ap-south-1.fc.aliyuncs.com/2016-08-15/proxy/contactForm/submitForm/"
      this.progress= true
      axios.post( serviceUrl,
        {
          'name': this.name,
          'email' : this.email,
          'phone' :this.phone,
          'city' :this.city,
          'segment': this.segment,
          'comment': this.comment,
          'monthlyConsumptions': this.monthlyConsumptions,
        }
      ).then(() => {
        this.progress=false
        this.submitted=true
      })
      .catch((e) => {
        /* eslint-disable no-console */
        console.log(e)
        /* eslint-enable no-console */
        this.progress=false
      })
    },
    clear(){
      this.$refs.contactForm.reset()
    },
  }
}
</script>

<style>
</style>
